<script lang="ts" setup></script>

<template>
  <div class="contact-info">
    <div class="contact-info__item">
      <nuxt-link to="https://hlh.tw/DLSjR">
        <svg-icon name="icon-line" class="line" />
        <span class="contact-info__item__text">Line 線上諮詢</span>
      </nuxt-link>
    </div>
    <div class="contact-info__item">
      <a href="tel:0800-251-209">
        <svg-icon name="icon-phone" class="phone" />
        <span class="contact-info__item__text">
          客服專線
          <span class="contact-info__item__tel"> 0800-251-209 </span>
        </span>
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.contact-info {
  &__item {
    margin-bottom: toRem(24);

    a {
      display: flex;
      align-items: center;
      font-size: toRem(16);
      color: $color-gray-1;
      transition: all 0.5s cubic-bezier(0.87, 0, 0.13, 1);

      &:hover {
        color: $color-brand-3;
      }

      svg {
        color: $color-brand-3;
        margin-right: toRem(10);
      }

      .line {
        width: toRem(36);
        height: toRem(36);
      }

      .phone {
        width: toRem(32);
        height: toRem(32);
        margin-right: toRem(14);
      }
    }

    &__text {
      display: flex;
      flex-direction: column;
    }

    &__tel {
      font-size: toRem(24);
      font-family: $font-TextaAlt;
      line-height: 0.8;
    }
  }
}
</style>
